<div class="box ml-2">
  <div class="box-header">


  </div>

  <!-- add user -->
  <div class="flex-align-center py-2 px-3" >
    <span class="font-weight-bold title-lg" >{{dcLocation}}</span>


    <button mat-stroked-button class="ml-auto" (click)="backToSummary()">
      <mat-icon>groups</mat-icon>
      {{'Back to DCs' | translate}}
    </button>
  </div>
  <div class="box-body ml-2 mr-2" >
    <form [formGroup]="dcForm">
      <div class="col ">
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline"  floatLabel="always">
              <mat-label >{{'DC #' | translate}}</mat-label>
              <input matInput maxlength="50" readonly="true" formControlName="dcLocation" required />
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'DC Licence' | translate}}</mat-label>
              <input maxlength="50" formControlName="dcLicense" appUserLicense matInput required/>
              <mat-error>
                @if (dcForm.get('dcLicense').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'DC Name' | translate}}</mat-label>
              <input matInput maxlength="50" appStoreName formControlName="dcName" />
              <mat-error>
                @if (dcForm.get('dcName').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col hide-sm"></div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'Street Address' | translate}}</mat-label>
              <input matInput maxlength="50" streetAddressVallidation required formControlName="dcAddress" />
              <mat-error>
                @if (dcForm.get('dcAddress').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'City' | translate}}</mat-label>
              <input matInput required maxlength="100" (input)="dcForm.controls.dcCity.setValue(dcForm.controls.dcCity.value.toUpperCase())" cityvalidation formControlName="dcCity" />
              <mat-error>
                @if (dcForm.get('dcCity').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'Province' | translate}}</mat-label>
              <input matInput required maxlength="2" minlength="2" appProvinceCode (input)="dcForm.controls.dcProvince.setValue(dcForm.controls.dcProvince.value.toUpperCase())" formControlName="dcProvince" />
              <mat-error>
                @if (dcForm.get('dcProvince').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col hide-sm"></div>

        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{'Postal Code' | translate}}</mat-label>
              <input matInput required maxlength="7" appPostalCode formControlName="dcPostal_code" />
              <mat-error>
                @if (dcForm.get('dcPostal_code').getError('invalid')) {
                  <span>
                    {{'Invalid Input' | translate}}
                  </span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col" >
            <mat-form-field appearance="outline" style="width: 100%!important;">
              <mat-label>{{'DC Email Accounts' | translate}}</mat-label>
              <mat-chip-grid #chipList formControlName="dcEmails">
                @for (emailId of dcEmailIds; track emailId) {
                <mat-chip-row class="{{emailId.invalid? 'chip-invalid': ''}}"
                  [removable]="removable" (removed)="remove(emailId.value)">
                    {{emailId.value}}
                    @if (removable) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
                <input placeholder="{{'New Email Id' | translate}}"
                  [matChipInputFor]="chipList"
                  maxlength="100"

                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="add($event)">
              </mat-chip-grid>
              <mat-error>
                {{ 'Invalid Email highlight in red' | translate }}
              </mat-error>
            </mat-form-field>

          </div>
          <!-- <div class="col hide-sm"></div> -->
          <!-- <div class="col hide-sm"></div> -->
        </div>

        <div class="row form-group flex-align-center">

          <div class="col text-right">
            <button mat-raised-button color="primary" [disabled]="!dcForm.valid" (click)="updateDcData()">{{'Save' | translate}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

